import {
    InputType,
    Form,
    FormField,
    FormSection,
    FormType,
    ReactiveDropdownCatalogs,
    ReactiveFormChangedField,
    ReactiveFormLifecycleEvent,
    ReactiveFormStableValueChange,
    ReactiveFormValue,
    DropdownData,
} from '@fitogest/reactive-form-builder/interfaces';
import { Component, OnInit } from '@angular/core';
import {FincasApiService} from '../../../../../service/api/fincas-api.service';
import {DashboardService} from '../../../../../service/events/dashboard.service';
import {FormCommonApiService} from '../../../../../service/api/formcommon-api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseForm} from '../../../../base-form';
import { buildWithParams, list, ReactiveSelectionResolver, stack, type ReactiveSelectionResolverConfiguration } from '@fitogest/reactive-form-builder/utils';
import {VisitasApiService} from '../../../../../service/api/visitas-api.service';
import {CitasModel} from '../../../../../models/citas/citas.model';
import {CitasApiService} from '../../../../../service/api/citas-api.service';
import {environment} from '../../../../../../environments/environment';
import { Filtering } from '../../../../../service/filtering/filtering';
import {StorageManager} from '../../../../../common/storage-manager.class';
import { SiexApiService } from '../../../../../service/api/siex-api.service';

import { VisitasModel } from 'src/app/models/visitas/visitas.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';

const VISITAS_DROPDOWN_SELECTION_CONFIGURATION: ReactiveSelectionResolverConfiguration = {
    idKeys: ['id', 'id_parcela', 'id_cultivo', 'codigo', 'value', 'variedad', 'cultivo'],
};

@Component({
    selector: 'app-visitas-form',
    standalone: false,
    templateUrl: './visitas-form.component.html',
    styleUrls: ['./visitas-form.component.scss']
})
export class VisitasFormComponent extends BaseForm<VisitasModel> implements OnInit {

    public appName = environment.appName;
    public applicationType = environment.features.applicationType;
    public hasClients = environment.features.hasClients;
    public showVisitasPlagas = environment.features.showVisitasPlagas;
    public showVisitaCarenciasMultiple = environment.features.showVisitaCarenciasMultiple;
    public showVisitasPascualCabedo = environment.features.showVisitasPascualCabedo;
    public showMoviendo = environment.features.showMoviendo;
    public showCosecha = environment.features.showCosecha;
    public showNumTallos = environment.features.showNumTallos;
    public showVisitasFisiopatias = environment.features.showVisitasFisiopatias;
    public showVisitasCultivos = environment.features.showVisitasCultivos;
    public showVisitasVariedades = environment.features.showVisitasVariedades;
    public isMelia = ((this.appName === 'melia') && (StorageManager.getUser().nombre === 'ALEJANDRO'));
    public showAllCultivosPrecedentes = environment.features.showAllCultivosPrecedentes;
    public showLocationLatLng = environment.features.showLocationLatLng;
    public hiddenVisitasCerezo = environment.features.hiddenVisitasCerezo;
    public hiddenVisitasContador = environment.features.hiddenVisitasContador;
    public showVisitasFormAbonosFolques = environment.features.showVisitasFormAbonosFolques;
    public showVisitasCamposPersonalizados = environment.features.showVisitasCamposPersonalizados;
    public showEstadoFenologicoAlmendro = environment.features.showEstadoFenologicoAlmendro;
    public showEstadoFenologicoVid = environment.features.showEstadoFenologicoVid;

    public override model: VisitasModel = {};
    public reactiveForm!: { formType: FormType; model: ReactiveFormValue<VisitasModel>; formFields: Form<VisitasModel> };

    public readonly reactiveFormLoadingLabel = 'Preparando formulario de visitas...';

    public isReactiveFormReady = false;

    public reactiveFormLoadingError = '';

    public initialPreviousData: VisitasModel | null = null;

    public reactiveFormRecordId = '';
    public id_finca = '';
    public cita: CitasModel = new CitasModel();

    public plagas = list(['...', null],
        'HONGOS DEL SUELO',
        'HONGOS ENDÓFITOS',
        'INSECTOS DEL SUELO',
        'NEMATODOS',
        'MALAS HIERBAS',
        'TOPOS',
        'BABOSAS',
        'BACTERIOSIS',
        'BARRENETA',
        'CARACOLES',
        'PREVENIR DESECACIÓN PLANTAS',
        'RETRASAR ENVEJECIMIENTO',
        'ÁCAROS',
        'ÁCARO ROJO',
        'ÁCAROS TETRANÍQUIDOS',
        'ARAÑA ROJA',
        'ARAÑA AMARILLA',
        'AGRIOTES',
        'AGUADO',
        'ARMILARIA',
        'CACOECIA',
        'CAPARRETA',
        'CERATITIS',
        'CERCÓPIDO',
        'CHANCRO',
        'CHINCHES',
        'ERIÓFIDOS',
        'ESCARABAJO',
        'EVITAR CAIDA FRUTO',
        'EVITAR CHOQUE TRANSPLANTE',
        'FITOPHTORA',
        'FOMOPSIS',
        'GOMOSIS',
        'GORGOJOS',
        'GRAMINEAS',
        'GRAMINEAS ANUALES',
        'GRAMINEAS VIVACES',
        'OIDIOPSIS',
        'GUSANOS BLANCOS',
        'GUSANOS DE ALAMBRE',
        'GUSANOS GRISES',
        'INDUCIR CUAJADO',
        'INDUCIR CUAJADO FLORES',
        'LARVAS DE DÍPTEROS',
        'LARVAS DE DIABROTICA',
        'LARVAS DE LEPIDÓPTEROS',
        'LAGARTA',
        'RIZOCTONIA',
        'SERPETA',
        'MINADORES DE HOJAS',
        'MOSCA BLANCA',
        'PULGONES',
        'ESTIMULAR ACTIVIDAD VEGETATIVA',
        'COLEÓPTEROS',
        'HORMIGAS',
        'INSECTOS',
        'AUMENTAR TAMAÑO FRUTO',
        'MOSQUITO VERDE',
        'PODREDUMBRE',
        'VERTICILIUM',
        'MALAS HIERBAS VIVACES',
        'MALAS HIERBAS ANUALES',
        'DICOTILEDONEAS ANUALES',
        'DICOTILEDONEAS',
        'ANTRACNOSIS',
        'ROYA',
        'STEMPHYLIUM',
        'ALTERNARIA',
        'BOTRITIS',
        'ESCLEROTINIA',
        'PHOMA',
        'TOPILLOS',
        'TIZON',
        'TETRANYCHUS URTICAE',
        'ALGAS',
        'MUSGOS',
        'MALAS HIERBAS MONOCOTILEDONEAS Y DICOTILEDONEAS',
        ('Micosphaerella').toUpperCase(),
        ('Septoria').toUpperCase(),
        'BROTACIÓN',
        'TOCONES',
        'TRIPS',
        'TORTRIX',
        'TUBERCULOSIS',
        'XANTHOMONAS',
        'POLILLAS',
        'PRAYS',
        'PROCESIONARIA',
        'PSEUDOMONAS',
        'PSILA',
        'PSILIDOS',
        'REBROTES DE CEREALES',
        'PHYLLOCNISTIS',
        'PHYTOPHTORA',
        'PIOJO BLANCO',
        'PIOJO GRIS',
        'PIOJO ROJO',
        'PIOJO ROJO CALIFORNIA',
        'PIOJOS',
        'PITIUM',
        'PLAGAS EN ESTADO HIBERNANTE',
        'PLUTELLA',
        'NEOPHILAENUS CAMPESTRIS',
        'NOCTUIDOS',
        'OIDIO',
        'ORTÓPTEROS',
        'ORUGAS',
        'PANONICHUS CITRI',
        'PARLATORIA',
        'PENICILIUM',
        'PHILAENUS SPUMARIUS',
        'CICADÉLIDOS',
        'CIPERACEAS',
        'COADYUVANTE',
        'COLETOTRICUM',
        'COTONET',
        'DÍPTEROS',
        'EOTETRANYCHUS CARPINI',
        'LEPIDÓPTEROS',
        'MAL SECO',
        'MALAS HIERBAS DE HOJA ANCHA',
        'MILDIU',
        'MINADORES',
        'MOSCA DE LA CEREZA',
        'MOSCA DE LA FRUTA',
    );

    public plagasFast = list(['...', null],
        ['----- PLAGAS -----', null],
        'Cochinilla',
        'Lagarta',
        'Mosca Blanca',
        'Araña Roja',
        'Thrips',
        'Picuda',
        ['----- ENFERMEDADES -----', null],
        'Fusarium',
        ['----- OTROS -----', null],
        'Malas Hierbas',
        'Nematodos',
        ['----- AUXILIARES -----', null],
        'Crisopas',
        'Sírfidos',
        'Fitoseidos',
        'Trichogramma',
        'Aves'
    );

    public plagasFolques = list(
        ['...', null],
        'Fauna salvaje',
        'Cotonet de Sudáfrica',
        'Trip orquidea',
        'Minador',
        'Prays',
        'Empoasca',
        'Cochinilla café',
        'Caparreta negra',
        'Serpeta',
        'Poll gris',
        'Mosca fruta',
        'Caracoles - Babosas',
        'Pezotrip',
        'Mosca blanca Paraleirodes',
        'Cotonet citricos',
        'Cochinilla acanalada',
        'Caparreta blanca',
        'Poll roch',
        'Mosca blanca algodonosa',
        'Pulgon algonodero',
        'Pulgon primavera',
        'Ácaro Maravillas',
        'Ácaro oriental',
        'Araña roja',
        'Ácaro rojo',
        'Lepra',
        'Alternaria',
        'Antracnosis',
        'Descamado patron',
        'Mancha grasienta',
        'Negrilla',
        'Fitophtora',
        'Melanosis',
        'Tristeza'
    );

    public estadoFast = list(
        ['...', null],
        ['Nivel Bajo', 'Bajo'],
        ['Vigilancia', 'Vigilancia'],
        ['Aplicar Control', 'Control'],
        ['Hay (AUXILIARES)', 'Hay'],
        ['No Hay (AUXILIARES)', 'No Hay']
    );

    public estadoPascualCabedo = list(
        ['...', null],
        'Mucho',
        'Regular',
        'Poco',
        'Muy poco',
        'Huevos',
        'Larvas',
        'Ninfas',
        'Adultas',
        'Inicio Brotación',
        'Brotación (+5cm)',
        'Brotación con Flores'
    );

    public estadosOrtizLavado = list(['...', null], 'Fitotoxicidad', 'Deficiente', 'Bueno');

    public concertadaValue = '';
    public concertada = list(['...', null], 'Si', 'No');
    public estado = list(['...', null], 'Mucho', 'Regular', 'Poco', ((this.appName === 'agromainsa') ? 'Presencia' : 'Muy Poco'));
    public umbral = list(
        ['...', null],
        '% Formas móviles',
        '% Brotes afectados',
        '% Hojas ocupadas',
        '% Fruta atacada',
        'Moscas/Mosquero/Día',
        'Condiciones meteorológicas favorables',
    );
    public parcelas = list<ParcelasModel>();
    public sectores = list<SectorModel>();
    public cultivos = list<VisitasVariedadMesModel>();
    public cultivosPrecedentes = list<VisitasVariedadMesModel>();
    public variedades = list<VisitasVariedadMesModel>();
    public estadoArbolado = list(['...', null], 'Bien', 'Regular', 'Mal');
    public moviendo = list(['...', null], 'Si', 'Poco', 'No');
    public cosecha = list(['...', null], 'Bien', 'Regular', 'Mal');
    public tamano = list(['...', null], 'Bien', 'Regular', 'Mal');
    public tamanoEspGranada = list(['...', null], 'Fino', 'Medio', 'Grueso');
    public humedad = list(['...', null], 'Subir', 'Bien', 'Bajar');
    public floracion = list(['...', null], 'Mucha', 'Regular', 'Poca');
    public tamanosFruta = list(['...', null], '0-40', '40-60', '+60');
    public listaCarencias = list(['...', null], 'Ca', 'Fe', 'Mg', 'Mn', 'N', 'Zn');
    public listaPorcentajes = list(['...', null], '10', '20', '30', '40', '50', '60', '70', '80', '90', '100');


    public estadoAranaRoja = list(
        ['...', null],
        'Huevos',
        'Larvas',
        'Ninfas',
        'Adultas'
    );

    public estadoBrotacion = list(
        ['...', null],
        'Inicio Brotación',
        'Brotación (+5cm)',
        'Brotación con Flores'
    );

    public estadoMalasHierbas = list(
        ['...', null],
        'Serreig',
        'Puntxo',
        'Juncia',
        'Heteranthera'
    );

    public cosechaAgromainsa = list(['...', null], 'Mucha', 'Normal', 'Regular', 'Poca');
    public aclareo = list(['...', null], 'Trasplantar', 'Birbar');
    public fisiopatias = list(
        'Repón o floración extratemporánea',
        'Creasing o Clareta',
        'Rajado fruta',
        'Pateta rata',
        'Retencion savia',
        'Viento',
        'Golpe sol',
        'Pedrisco',
        'Pulgón',
        'Pyricularia',
        'Helminthosporium',
        'Anoxia',
        'Salinidad'
    );

    public estadios = list(
        ['...', null],
        'Larva',
        'Ninfa',
        'Huevo',
        'Ciclo completo',
        'Adulto'
    );

    public estadoFisiologico = list(
        ['...', null],
        '1 hoja',
        '2 hojas',
        '1 hijo',
        'Más de 2 hijos',
        'Encañado',
        'Inicio de espiga',
        'Espiga'
    );

    public estadoFisiologicoCebolla = list(
        ['...', null],
        'Gancho',
        'Bandera',
        '1ª hoja verdadera',
        '2 hojas',
        '4 hojas',
        '5 hojas',
        '6 hojas',
        '7 hojas',
        '8 hojas',
        '9 hojas',
        '10 hojas',
        '11 hojas',
        '12 hojas'
    );

    public estadoBulboCebolla = list(
        ['...', null],
        'Inicio del Bulbado',
        'Bulbando',
        'Fin del Bulbado'
    );

    public estadoFenologicoAlmendro = list(
        ['...', null],
        'Yemas de Invierno',
        'Yemas Hinchadas',
        'Cáliz Visible',
        'Corola Visible',
        'Estambres Visibles',
        'Flor Abierta',
        'Caída de Pétalos',
        'Fruto Cuajado',
        'Fruto Joven',
        'Fruto en Evolución hacia la Madurez'
    );
    public estadoFenologicoVid = list(
        ['...', null],
        'Brotación',
        'Desarrollo de las Hojas',
        'Aparición del Organo Floral',
        'Floración',
        'Formación del Fruto',
        'Maduración de Frutos',
        'Comienzo del Reposo Vegetativo'
    );

    public plagasFormFields: any[] = [
];

    public formFieldsCarencias: FormField<any>[] = [
    {
        name: 'carencia1',
        field: 'carencia1',
        label: 'Carencia 1',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.listaCarencias)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.listaCarencias)),

        order: 1
    },
    {
        name: 'porcentaje_carencia1',
        field: 'porcentaje_carencia1',
        label: 'Porcentaje de carencia 1',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.listaPorcentajes)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.listaPorcentajes)),

        order: 2
    },
    {
        name: 'carencia2',
        field: 'carencia2',
        label: 'Carencia 2',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.listaCarencias)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.listaCarencias)),

        order: 3
    },
    {
        name: 'porcentaje_carencia2',
        field: 'porcentaje_carencia2',
        label: 'Porcentaje de carencia 2',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.listaPorcentajes)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.listaPorcentajes)),

        order: 4
    },
    {
        name: 'carencia3',
        field: 'carencia3',
        label: 'Carencia 3',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.listaCarencias)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.listaCarencias)),

        order: 5
    },
    {
        name: 'porcentaje_carencia3',
        field: 'porcentaje_carencia3',
        label: 'Porcentaje de carencia 3',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.listaPorcentajes)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.listaPorcentajes)),

        order: 6
    },
];

    public formFields: FormField<any>[] = [
    {
        name: 'estado_arbolado',
        field: 'estado_arbolado',
        label: 'Estado del arbolado',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.estadoArbolado, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez') },
        required: false,
        visible: this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez',        values: this.estadoArbolado,

        order: 1
    },
    {
        name: 'moviendo',
        field: 'moviendo',
        label: 'Moviendo',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.moviendo, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showMoviendo) },
        required: false,
        visible: this.showMoviendo,        values: this.moviendo,

        order: 2
    },
    {
        name: 'estado_cosecha',
        field: 'estado_cosecha',
        label: 'Cosecha',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.cosecha, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showCosecha) },
        required: false,
        visible: this.showCosecha,        values: this.cosecha,

        order: 3
    },
    {
        name: 'num_tallos',
        field: 'num_tallos',
        label: 'Nº Tallos',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showNumTallos) },
        required: false,
        visible: this.showNumTallos,
        order: 4
    },
    {
        name: 'tamanyo',
        field: 'tamanyo',
        label: (this.appName === 'esparragosgranada') ? 'Calibre' : 'Tamaño',
        input: { type: InputType.DROPDOWN, isEditable: true, data: (this.appName === 'esparragosgranada') ? this.tamanoEspGranada : this.tamano, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez') },
        required: false,
        visible: this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez',        values: (this.appName === 'esparragosgranada') ? this.tamanoEspGranada : this.tamano,

        order: 5
    },
    {
        name: 'tamano_fruta',
        field: 'tamano_fruta',
        label: 'Calibre de la fruta',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.tamanosFruta, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean((this.appName === 'pascualcabedo')) },
        required: false,
        visible: (this.appName === 'pascualcabedo'),        values: this.tamanosFruta,

        order: 6
    },
    {
        name: 'humedad',
        field: 'humedad',
        label: 'Humedad',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.humedad, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez') },
        required: false,
        visible: this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez',        values: this.humedad,

        order: 7
    },
    {
        name: 'estado_floracion',
        field: 'estado_floracion',
        label: 'Floración',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.floracion, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez') },
        required: false,
        visible: this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez',        values: this.floracion,

        order: 8
    },
    {
        name: 'id_cultivo',
        field: 'id_cultivo',
        label: 'Cultivo',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.cultivos, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: { value: VisitasVariedadMesModel; }) => (this.parcelas.values || [])
                .map(p => p.value)
                .filter((p): p is ParcelasModel => p !== null)
                .filter(p => p.id_finca === this.id_finca)
                .some(p => {
                    const cultivo = it.value;
                    if (p.id_cultivo === cultivo.id) {
                        cultivo.id_parcela = p.id;
                    }
                    return p.id_cultivo === cultivo.id;
                }) }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasCultivos) },
        required: false,
        visible: this.showVisitasCultivos,        values: this.cultivos,

        order: 9
    },
    {
        name: 'id_variedad',
        field: 'id_variedad',
        label: 'Variedad/es',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.variedades, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: { value: VisitasVariedadMesModel; }) => (this.parcelas.values || [])
                .map(p => p.value)
                .filter((p): p is ParcelasModel => p !== null)
                .filter(p => p.id_finca === this.id_finca)
                .some(p => {
                    const variedad = it.value;

                    if (p.id_variedad === variedad.id) {
                        variedad.id_parcela = p.id;
                    }
                    return p.id_variedad === variedad.id;
                }) }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasVariedades) },
        required: false,
        visible: this.showVisitasVariedades,        values: this.variedades,

        order: 10
    },
    {
        name: 'calidad_agua',
        field: 'calidad_agua',
        label: 'Calidad Agua',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez') },
        required: false,
        visible: this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez',
        order: 11
    },
    {
        name: 'estado_fisiologico',
        field: 'estado_fisiologico',
        label: this.appName === 'pedrosaez' ? 'Estado Fisiológico del Cereal' : 'Estado Fisiológico',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.estadoFisiologico, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName === 'agropecuariaramirogruas' || this.appName === 'pedrosaez') },
        required: false,
        visible: this.appName === 'agropecuariaramirogruas' || this.appName === 'pedrosaez',        values: this.estadoFisiologico,

        order: 12
    },
    {
        name: 'estado_fisiologico_cebolla',
        field: 'estado_fisiologico_cebolla',
        label: 'Estado Fisiológico de la Cebolla',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.estadoFisiologicoCebolla, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName === 'pedrosaez') },
        required: false,
        visible: this.appName === 'pedrosaez',        values: this.estadoFisiologicoCebolla,

        order: 13
    },
    {
        name: 'estado_bulbo_cebolla',
        field: 'estado_bulbo_cebolla',
        label: 'Estado del Bulbo de la Cebolla',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.estadoBulboCebolla, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName === 'pedrosaez') },
        required: false,
        visible: this.appName === 'pedrosaez',        values: this.estadoBulboCebolla,

        order: 14
    },
    {
        name: 'observaciones',
        field: 'observaciones',
        label: 'Observaciones',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { hasVoiceTranscription: Boolean(false), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 15
    },
    {
        name: 'aclareo',
        field: 'aclareo',
        label: 'Aclareo',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.aclareo, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.applicationType === 'cropgest') },
        required: false,
        visible: this.applicationType === 'cropgest',        values: this.aclareo,

        order: 16
    },
    {
        name: 'fisiopatias',
        field: 'fisiopatias',
        label: 'Fisiopatías',
        input: { type: InputType.MULTISELECT_SEARCH, isEditable: true, data: this.fisiopatias, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasFisiopatias) },
        required: false,
        visible: this.showVisitasFisiopatias,        values: this.fisiopatias,

        order: 17
    },
    {
        name: 'concertada',
        field: 'concertada',
        label: 'Concertada',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.concertada, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez') },
        required: false,
        visible: this.appName !== 'agropecuariaramirogruas' && this.appName !== 'pedrosaez',        values: this.concertada,

        order: 18
    },
];


    public formFieldsArmentia: FormField<any>[] = [
    {
        name: 'id_cultivo',
        field: 'id_cultivo',
        label: 'Cultivo',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.cultivos, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: { value: VisitasVariedadMesModel; }) => (this.parcelas.values || [])
                .map(p => p.value)
                .filter((p): p is ParcelasModel => p !== null)
                .filter(p => p.id_finca === this.id_finca)
                .some(p => {
                    const cultivo = it.value as VisitasVariedadMesModel;

                    if (p.id_cultivo === cultivo.id) {
                        cultivo.id_parcela = p.id;
                    }
                    return p.id_cultivo === cultivo.id;
                }) }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.cultivos,

        order: 1
    },
    {
        name: 'estado_desarrollo_cultivo',
        field: 'estado_desarrollo_cultivo',
        label: 'Estado desarrollo cultivo',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'fecha_siembra',
        field: 'fecha_siembra',
        label: 'Fecha de siembra',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
    {
        name: 'dosis_siembra',
        field: 'dosis_siembra',
        label: 'Dosis de siembra',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'id_cultivo_precedente',
        field: 'id_cultivo_precedente',
        label: 'Cultivo precedente',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.cultivosPrecedentes, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: { value: VisitasVariedadMesModel; }) => (this.parcelas.values || [])
                .map(p => p.value)
                .filter((p): p is ParcelasModel => p !== null)
                .filter(p => p.id_finca === this.id_finca)
                .some(p => {
                    const cultivo = it.value;
                    if (p.id_cultivo === cultivo.id) {
                        cultivo.id_parcela = p.id;
                    }
                    return p.id_cultivo === cultivo.id;
                }) }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showAllCultivosPrecedentes) },
        required: false,
        visible: !this.showAllCultivosPrecedentes,        values: this.cultivosPrecedentes,

        order: 5
    },
    {
        name: 'id_cultivo_precedente',
        field: 'id_cultivo_precedente',
        label: 'Cultivo precedente',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.cultivosPrecedentes, dropdownConfiguration: { valuePrimaryKey: 'id', filter: () => {
                Filtering.distinctBy.bind({field: 'label'});
                return true;
            } }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showAllCultivosPrecedentes) },
        required: false,
        visible: this.showAllCultivosPrecedentes,        values: this.cultivosPrecedentes,

        order: 6
    },
    {
        name: this.appName === 'armentia' ? 'observaciones' : 'Observaciones',
        field: this.appName === 'armentia' ? 'observaciones' : 'Observaciones',
        label: 'Observaciones',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { hasVoiceTranscription: Boolean(false), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 7
    },
];


    public formFieldsFast: FormField<any>[] = [
    {
        name: 'id_variedad',
        field: 'id_variedad',
        label: 'Variedad/es',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.variedades, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: { value: VisitasVariedadMesModel; }) => (this.parcelas.values || [])
                .map(p => p.value)
                .filter((p): p is ParcelasModel => p !== null)
                .filter(p => p.id_finca === this.id_finca)
                .some(p => {
                    const variedad = it.value;

                    if (p.id_variedad === variedad.id) {
                        variedad.id_parcela = p.id;
                    }

                    return p.id_variedad === variedad.id;
                }) }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.variedades,

        order: 1
    },
];

    public formFieldsPrevilsa: FormField<any>[] = [
    {
        name: 'tipo_visita',
        field: 'tipo_visita',
        label: 'Tipo de visita',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null],
                'Primera visita',
                'Visita a obra',
                'Visita de cortesía',
                'Visita por reclamación',
                'Entrega de tarifas',
                'Negociación de condiciones'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: list(['...', null],
                'Primera visita',
                'Visita a obra',
                'Visita de cortesía',
                'Visita por reclamación',
                'Entrega de tarifas',
                'Negociación de condiciones'),

        order: 1
    },
    {
        name: 'observaciones',
        field: 'observaciones',
        label: 'Notas',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { hasVoiceTranscription: Boolean(false), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
];

    public formFieldsFolques: FormField<any>[] = [
    {
        name: 'id_variedad',
        field: 'id_variedad',
        label: 'Variedad/es',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.variedades, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: { value: VisitasVariedadMesModel; }) => {
                const variedad = it.value as VisitasVariedadMesModel;

                const selectedParcela = this.resolveSelectedDropdownEntity('id_parcela', this.parcelas);

                if (selectedParcela === null) {
                    return this.resolveSelectedDropdownEntity('id_variedad', this.variedades)?.id === variedad.id;
                }
                return (this.parcelas.values || [])
                    .map(p => p.value)
                    .filter((p): p is ParcelasModel => p !== null)
                    .filter(p => p.id_finca === this.id_finca)
                    .some(p => {
                        if (p.id_variedad === variedad.id) {
                            variedad.id_parcela = p.id;
                        }
                        return p.id_variedad === variedad.id;
                    });
            } }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasVariedades) },
        required: false,
        visible: this.showVisitasVariedades,        values: this.variedades,

        order: 1
    },
    {
        name: 'kg_recolectados',
        field: 'kg_recolectados',
        label: 'Previsión de aforo',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'calibre_medio_fruto',
        field: 'calibre_medio_fruto',
        label: 'Calibre medio fruto',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
    {
        name: 'calibre_aclareo',
        field: 'calibre_aclareo',
        label: 'Calibre aclareo',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'caida_hojas_suelo',
        field: 'caida_hojas_suelo',
        label: 'Caída hojas suelo',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 5
    },
    {
        name: 'estado_malas_hierbas',
        field: 'estado_malas_hierbas',
        label: 'Estado Malas Hierbas',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.estadoMalasHierbas, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.estadoMalasHierbas,

        order: 6
    },
    {
        name: 'aplicar_nutrientes_general',
        field: 'aplicar_nutrientes_general',
        label: 'Aplicar nutrientes general',
        input: { type: InputType.SWITCH, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 7
    },
    {
        name: 'estado_fenologico',
        field: 'estado_fenologico',
        label: 'Estado Fenológico',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(
                ['...', null],
                'Fruto maduro 89',
                'Fruto cuajado 71-H',
                'Crecimiento del fruto 73-I',
                'Comienzo de la floración 60-E',
                'Primeras hojas totalmente expandidas 19',
                'Caida petalos CI 69-72',
                'Desarrollo fruto CI 71-79',
                'Floración botón CI 31-59'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: list(
                ['...', null],
                'Fruto maduro 89',
                'Fruto cuajado 71-H',
                'Crecimiento del fruto 73-I',
                'Comienzo de la floración 60-E',
                'Primeras hojas totalmente expandidas 19',
                'Caida petalos CI 69-72',
                'Desarrollo fruto CI 71-79',
                'Floración botón CI 31-59'),

        order: 8
    },
    {
        name: 'estado_fenologico_almendro',
        field: 'estado_fenologico_almendro',
        label: 'Estado Fenológico Almendro',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null],
                'A Yemas de Invierno',
                'B Yemas Hinchadas',
                'C Cáliz Visible',
                'D Corola Visible',
                'E Estambres Visibles',
                'F Flor Abierta',
                'G Caída de Pétalos',
                'H Fruto Cuajado',
                'I Fruto Joven',
                'J Fruto en Evolución Hacia la Madurez',
            ), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showEstadoFenologicoAlmendro) },
        required: false,
        visible: this.showEstadoFenologicoAlmendro,        values: list(['...', null],
                'A Yemas de Invierno',
                'B Yemas Hinchadas',
                'C Cáliz Visible',
                'D Corola Visible',
                'E Estambres Visibles',
                'F Flor Abierta',
                'G Caída de Pétalos',
                'H Fruto Cuajado',
                'I Fruto Joven',
                'J Fruto en Evolución Hacia la Madurez',
            ),

        order: 9
    },
    {
        name: 'estado_fenologico_vid',
        field: 'estado_fenologico_vid',
        label: 'Estado Fenológico Vid',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null],
                `00 Letargo: las yemas de invierno, de puntiagudas a redondeadas, marrón brillante u oscuro según la variedad;
                 escamas de las yemas cerradas, de acuerdo con la variedad`,
                '01 Comienzo del hinchado de las yemas; los botones empiezan a hincharse dentro de las escamas',
                '03 Fin del hinchado de las yemas: yemas, hinchadas, pero no verdes',
                '05 "Estadio lanoso"; lana marrón, claramente visible',
                '07 Comienzo de la apertura de las yemas: ápices foliares verdes, apenas visibles',
                '09 Apertura de las yemas: ápices foliares claramente visibles',
                '10 Desarrollo de las Hojas',
                '53 Inflorescencias, claramente visibles',
                '55 Inflorescencias hinchándose; las flores apretadas entre sí',
                '57 Inflorescencias, desarrolladas completamente; flores separándose',
                '61 Comienzo de la floración: alrededor de 10 % de capuchones caídos',
                '69 Fin de la floración',
                '71 Cuajado de frutos; los frutos jóvenes comienzan a hincharse; los restos florales perdidos',
                '73 Bayas del tamaño de un perdigón, los racimos comienzan a pender',
                '75 Bayas de tamaño guisante (arvejas); los racimos, colgantes',
                '77 Las bayas comienzan a tocarse',
                '79 Todas las bayas de un racimo se tocan',
                '81 Comienzo de la maduración; las bayas comienzan a brillar',
                '83 Las bayas, brillantes',
                '85 Ablandamiento de las bayas',
                '89 Bayas, listas para recolectarse',
                '91 Después de la vendimia; fin de la maduración de la madera',
                '92 Comienzo de la decoloración foliar',
                '93 Comienzo de la caída de las hojas',
                '95 Alrededor de 50 % de las hojas caídas',
                '97 Fin de la caída de las hojas',
                '99 Partes cosechadas'
            ), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showEstadoFenologicoVid) },
        required: false,
        visible: this.showEstadoFenologicoVid,        values: list(['...', null],
                `00 Letargo: las yemas de invierno, de puntiagudas a redondeadas, marrón brillante u oscuro según la variedad;
                 escamas de las yemas cerradas, de acuerdo con la variedad`,
                '01 Comienzo del hinchado de las yemas; los botones empiezan a hincharse dentro de las escamas',
                '03 Fin del hinchado de las yemas: yemas, hinchadas, pero no verdes',
                '05 "Estadio lanoso"; lana marrón, claramente visible',
                '07 Comienzo de la apertura de las yemas: ápices foliares verdes, apenas visibles',
                '09 Apertura de las yemas: ápices foliares claramente visibles',
                '10 Desarrollo de las Hojas',
                '53 Inflorescencias, claramente visibles',
                '55 Inflorescencias hinchándose; las flores apretadas entre sí',
                '57 Inflorescencias, desarrolladas completamente; flores separándose',
                '61 Comienzo de la floración: alrededor de 10 % de capuchones caídos',
                '69 Fin de la floración',
                '71 Cuajado de frutos; los frutos jóvenes comienzan a hincharse; los restos florales perdidos',
                '73 Bayas del tamaño de un perdigón, los racimos comienzan a pender',
                '75 Bayas de tamaño guisante (arvejas); los racimos, colgantes',
                '77 Las bayas comienzan a tocarse',
                '79 Todas las bayas de un racimo se tocan',
                '81 Comienzo de la maduración; las bayas comienzan a brillar',
                '83 Las bayas, brillantes',
                '85 Ablandamiento de las bayas',
                '89 Bayas, listas para recolectarse',
                '91 Después de la vendimia; fin de la maduración de la madera',
                '92 Comienzo de la decoloración foliar',
                '93 Comienzo de la caída de las hojas',
                '95 Alrededor de 50 % de las hojas caídas',
                '97 Fin de la caída de las hojas',
                '99 Partes cosechadas'
            ),

        order: 10
    },
    {
        name: 'cerezos',
        field: 'cerezos',
        label: 'Cerezos',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null],
                'Ápices florales verdes D 10',
                'Cuajado engorde I 73',
                'Cuajado inicio H 71',
                'Flor abierta F 85',
                'Hinchado yemas B 03',
                'Letargo A 00',
                'Maduración J 87',
                'Yemas florales hinchadas D 55',
            ), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean((this.appName === 'ava' ? false : true) && !this.hiddenVisitasCerezo) },
        required: false,
        visible: (this.appName === 'ava' ? false : true) && !this.hiddenVisitasCerezo,        values: list(['...', null],
                'Ápices florales verdes D 10',
                'Cuajado engorde I 73',
                'Cuajado inicio H 71',
                'Flor abierta F 85',
                'Hinchado yemas B 03',
                'Letargo A 00',
                'Maduración J 87',
                'Yemas florales hinchadas D 55',
            ),

        order: 11
    },
    {
        name: 'fisiopatias',
        field: 'fisiopatias',
        label: 'Fisiopatías',
        input: { type: InputType.MULTISELECT_SEARCH, isEditable: true, data: this.fisiopatias, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.fisiopatias,

        order: 12
    },
    {
        name: 'lectura_contador',
        field: 'lectura_contador',
        label: 'Lectura contador',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 13
    },
    {
        name: 'carencias',
        field: 'carencias',
        label: 'Carencias',
        input: { type: InputType.MULTISELECT_SEARCH, isEditable: true, data: list('Ca', 'Fe', 'Mg', 'Mn', 'N', 'Zn'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitaCarenciasMultiple) },
        required: false,
        visible: !this.showVisitaCarenciasMultiple,        values: list('Ca', 'Fe', 'Mg', 'Mn', 'N', 'Zn'),

        order: 14
    },
    {
        name: 'porcentaje_carencia',
        field: 'porcentaje_carencia',
        label: 'Porcentaje de carencia',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], '10', '20', '30', '40', '50', '60', '70', '80', '90', '100'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitaCarenciasMultiple) },
        required: false,
        visible: !this.showVisitaCarenciasMultiple,        values: list(['...', null], '10', '20', '30', '40', '50', '60', '70', '80', '90', '100'),

        order: 15
    },
    {
        name: 'observaciones',
        field: 'observaciones',
        label: 'Observaciones',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { hasVoiceTranscription: Boolean(false), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 16
    },
];

    public formFieldsMelia: FormField<any>[] = [
    {
        name: 'poda',
        field: 'poda',
        label: 'Poda',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], 'Pendiente', 'Realizada', 'No podar'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: list(['...', null], 'Pendiente', 'Realizada', 'No podar'),

        order: 1
    },
    {
        name: 'estado_fenologico',
        field: 'estado_fenologico',
        label: 'Estado fenológico',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], 'Parada vegetativa', 'Brotación', 'Floración', 'Cuajado', 'Caída fisiológica',
                'Crecimiento Fruto', 'Maduración', 'Recolección'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: list(['...', null], 'Parada vegetativa', 'Brotación', 'Floración', 'Cuajado', 'Caída fisiológica',
                'Crecimiento Fruto', 'Maduración', 'Recolección'),

        order: 2
    },
    {
        name: 'cosecha',
        field: 'cosecha',
        label: 'Cosecha',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], 'Alta', 'Media', 'Baja'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: list(['...', null], 'Alta', 'Media', 'Baja'),

        order: 3
    },
    {
        name: 'tamanyo',
        field: 'tamanyo',
        label: 'Tamaño (mm)',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 4
    },
    {
        name: 'humedad',
        field: 'humedad',
        label: 'Humedad',
        input: { type: InputType.DROPDOWN, isEditable: true, data: list(['...', null], 'Subir', 'Óptima', 'Bajar'), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: list(['...', null], 'Subir', 'Óptima', 'Bajar'),

        order: 5
    },
    {
        name: 'estado_floracion',
        field: 'estado_floracion',
        label: 'Floración',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.floracion, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.floracion,

        order: 6
    },
];



    private createReactiveForm(): void {
        const formType = Number(this.getType()) as FormType;
        this.reactiveForm = {
            formType,
            model: this.toVisitasFormValue(this.model),
            formFields: {
                name: 'visitas',
                header: this.getType() === FormType.EDITION ? this.headerTitleWhenEdit : this.headerTitleWhenNew,
                type: formType,
                sections: this.getReactiveSections(),
                table: null,
                uploadButton: { isEnabled: Boolean(false), label: '' },
                signed: Boolean(false),
                dropdownCatalogs: this.getDropdownCatalogs(),
            },
        };
        this.configureDeclarativeDropdownCatalogs();
    }

    private getReactiveSections(): FormSection<VisitasModel>[] {
        return [
            { name: 'Datos de visita', fields: this.formFields, width: 12, isVisible: true, order: 1 },
            { name: 'Carencias', fields: this.formFieldsCarencias, isVisible: this.formFieldsCarencias.length > 0, width: 12, order: 2 },
            { name: 'Plagas', fields: this.plagasFormFields, isVisible: this.plagasFormFields.length > 0, width: 12, order: 3 },
        ];
    }

    public stableValueChanges(event: ReactiveFormStableValueChange<VisitasModel>): void {
        const stableValue = this.captureStableValueChange(event.value as VisitasModel);

        this.reactiveForm.model = this.toVisitasFormValue(stableValue);
        this.syncModelFromForm();

        if (event.origin !== 'user') {
            return;
        }

        this.handleUserValueChange(event.value, event.changedField);
    }

    public onReactiveFormLifecycleEvent(event: ReactiveFormLifecycleEvent<VisitasModel>): void {
        if (event.type !== 'previousDataPatched' && event.type !== 'previousDataChanged') {
            return;
        }

        const stableValue = this.captureStableValueChange(event.value as VisitasModel);

        this.reactiveForm.model = this.toVisitasFormValue(stableValue);
        this.hydrateVisitasDropdownSeeds(stableValue);
        this.syncModelFromForm();
        this.refreshReactiveDropdownMappings();
    }

    public onAfterSend(): void {
        if (!this.cita?.id) {
            return;
        }

        this.model.concertada = this.concertadaValue;
        this.citasApi.citas.PUT.response(() => {
            this.citasApi.citas.PUT.unsuscribe();
        });

        const selectedVariedad = this.resolveSelectedDropdownEntity('id_variedad', this.variedades);
        const selectedCultivo = this.resolveSelectedDropdownEntity('id_cultivo', this.cultivos);

        this.citasApi.citas.PUT.perform({
            id: this.cita.id,
            concertada: this.concertadaValue,
            id_parcela: selectedVariedad?.id_parcela
                || selectedCultivo?.id_cultivo
                || '',
        } as never);
    }

    private resolveSelectedDropdownEntity<T extends object>(fieldName: string, dropdown: DropdownData<T>): T | null {
        const currentValue = this.formBuilderRef?.model?.get(fieldName)?.value
            ?? (this.model as Record<string, unknown>)[fieldName];

        return ReactiveSelectionResolver.resolveSelectedEntities(
            dropdown,
            currentValue,
            VISITAS_DROPDOWN_SELECTION_CONFIGURATION,
        )[0] ?? null;
    }

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public visitasApi: VisitasApiService,
        public citasApi: CitasApiService,
        public fincasApi: FincasApiService,
        public formApi: FormCommonApiService,
        public siexApi: SiexApiService,
        public override dashboard: DashboardService
    ) {
        super(
            route,
            router,
            dashboard,
            visitasApi.visitasPUT,
            visitasApi.visitasPOST,
            'visitas',
            'Editar Visita',
            'Crear Visita',
            'Duplicar Visita'
        );
    }

    ngOnInit() {

        if (this.appName === 'armentia') {
            this.formFields = this.formFieldsArmentia;
        }
        if (this.appName === 'lafast') {
            this.plagas = this.plagasFast;
            this.estado = this.estadoFast;
            this.formFields = this.formFieldsFast;
        }
        if (this.appName === 'ortizlavado') {
            this.estado = this.estadosOrtizLavado;
        }
        if (this.appName === 'pascualcabedo') {
            this.estado = this.estadoPascualCabedo;
        }
        if (this.appName === 'previlsa') {
            this.formFields = this.formFieldsPrevilsa;
        }
        if (this.showVisitasCamposPersonalizados || this.showVisitasFormAbonosFolques ) {
            if ( this.appName !== 'lluchychulbi' ) {
                this.plagas = this.plagasFolques;
            }

            this.formFields = this.formFieldsFolques;
        }
        if (this.appName === 'agromainsa') {
            const indexEstadoCosecha = this.formFields.map(it => it.name).indexOf('estado_cosecha') ?? '';
            (this.formFields[indexEstadoCosecha] as FormField<object>).input.data = this.cosechaAgromainsa;
        }
        if (this.isMelia) {
            this.formFields = this.formFieldsMelia;
            this.estado = this.umbral;
        }

        this.initFields();

        if (this.route.snapshot.queryParams['cita']) {
            this.cita = JSON.parse(this.route.snapshot.queryParams['cita']);
            this.id_finca = this.cita.id_finca;
        }


        if (this.hasClients) {
        }


        void this.initializeVisitasForm();

    }

    private async initializeVisitasForm(): Promise<void> {
        try {
            this.isReactiveFormReady = false;
            this.reactiveFormLoadingError = '';
            this.resetExternalDropdowns();
            this.softInit(this.getType());
            const routeModel = this.toVisitasModel(this.getModel() as unknown as Record<string, unknown>);
            this.reactiveFormRecordId = this.resolveReactiveFormRecordId(routeModel);
            this.initializeHostModel(routeModel);
            this.initialPreviousData = this.getInitialPreviousData(routeModel);
            this.createReactiveForm();
            await this.initFormData();
            this.markReactiveFormReady();
        } catch (error: unknown) {
            this.reactiveFormLoadingError = this.getReadableInitialisationError(error);
            this.finalizeExternalDropdowns();
            console.error('No se ha podido preparar el formulario de visitas.', error);
        }
    }

    private handleUserValueChange(
        _formModel: ReactiveFormValue<VisitasModel>,
        lastChangedFieldName: ReactiveFormChangedField<VisitasModel>,
    ): void {
        this.handleReactiveValueChange(String(lastChangedFieldName ?? ''));
    }

    private handleReactiveValueChange(tag: string): void {
        if (tag === 'concertada') {
            this.concertadaValue = this.model[tag] ?? '';
        }
    }

    private initFields(): void {
        this.plagas.filtered.sort(
            Filtering.sort('label', 1)
        );

        for (let i = 0; i < 4; i++) {
            if (environment.features.plagasInput === true) {
                this.plagasFormFields.push({
                    label: (i === 0) ? 'Plagas' : '',
                    field: 'plaga' + (i + 1),
                    inputType: {type: InputType.TEXT}
                });
            } else {
                this.plagasFormFields.push({
                    label: (i === 0) ? 'Listado de plagas' : '',
                    field: 'plaga' + (i + 1),
                    inputType: {type: InputType.DROPDOWN},
                    values: JSON.parse(JSON.stringify(this.plagas))
                });
            }

            this.plagasFormFields.push({
                label: (i === 0) ? 'Incidencia' : '',
                field: 'estado_plaga' + (i + 1),
                inputType: {type: InputType.DROPDOWN},
                values: JSON.parse(JSON.stringify(this.estado)),
                visible: !this.isMelia
            });
            this.plagasFormFields.push({
                label: (i === 0) ? 'Estadio' : '',
                field: 'estadio' + (i + 1),
                inputType: {type: InputType.DROPDOWN},
                values: JSON.parse(JSON.stringify(this.estadios)),
                visible: !this.isMelia
            });


            if (this.isMelia) {
                this.plagasFormFields.push({
                    label: (i === 0) ? 'Umbral' : '',
                    field: 'estado_plaga' + (i + 1),
                    inputType: {type: InputType.DROPDOWN},
                    values: JSON.parse(JSON.stringify(this.estado))
                });
                this.plagasFormFields.push({
                    label: 'Cantidad',
                    field: 'cantidad' + (i + 1),
                    inputType: {type: InputType.NUMERIC}
                });
            }
        }
    }


    private async initFormData(): Promise<void> {
        const params = this.getCatalogParams();

        await stack([
            buildWithParams(this.fincasApi.parcelasGET, params, this.parcelas, 'id_variedad', true),
        ]);

        this.model.concertada = this.cita.concertada ?? '';
        this.reactiveForm.model = this.toVisitasFormValue({
            ...this.reactiveForm.model,
            ...this.model,
        });
    }

    private markReactiveFormReady(): void {
        this.isReactiveFormReady = true;
        this.finalizeExternalDropdowns();
        this.refreshReactiveDropdownMappings();
    }

    private syncModelFromForm(): void {
        const normalizedModel = this.toVisitasModel(this.reactiveForm.model);

        this.reactiveForm.model = this.toVisitasFormValue(normalizedModel);
        this.updateHostModel(normalizedModel);
    }

    private refreshReactiveDropdownMappings(): void {
        this.formBuilderRef?.requestExternalDropdownMappingsRefresh();
    }

    private getCatalogParams(): Record<string, unknown> {
        return this.hasClients ? { id_cliente: this.cita.id_cliente } : {};
    }

    private getDropdownCatalogs(): ReactiveDropdownCatalogs {
        return {
            critical: [],
            deferred: ['id_cultivo', 'id_cultivo_precedente'],
            lazy: ['id_variedad'],
        };
    }

    private configureDeclarativeDropdownCatalogs(): void {
        this.configureDropdownDataSource('id_cultivo', {
            cacheKey: 'visitas-cultivos',
            endpoint: environment.features.activateSIEX ? this.siexApi.cultivosGET : this.formApi.cultivosGET,
            labelKey: 'cultivo',
            distinctBy: 'id',
            filterOption: (option) => this.matchesVisitasCultivoOption(option.raw ?? option.value),
        });
        this.configureDropdownDataSource('id_cultivo_precedente', {
            cacheKey: 'visitas-cultivos-precedentes',
            endpoint: environment.features.activateSIEX ? this.siexApi.cultivosGET : this.formApi.cultivosGET,
            labelKey: 'cultivo',
            distinctBy: 'id',
            filterOption: (option) => this.showAllCultivosPrecedentes || this.matchesVisitasCultivoOption(option.raw ?? option.value),
        });
        this.configureDropdownDataSource('id_variedad', {
            cacheKey: 'visitas-variedades',
            endpoint: environment.features.activateSIEX ? this.siexApi.variedadesGET : this.formApi.variedadesGET,
            lazy: true,
            labelKey: 'variedad',
            distinctBy: 'id',
            filterOption: (option) => this.matchesVisitasVariedadOption(option.raw ?? option.value),
        });
    }

    private configureDropdownDataSource(
        fieldName: string,
        dataSource: NonNullable<FormField<VisitasModel>['dataSource']>,
    ): void {
        for (const field of this.getReactiveFields(fieldName)) {
            field.dataSource = {
                ...dataSource,
                params: () => this.getCatalogParams(),
                cacheEmptyResults: false,
            };
        }
    }

    private getReactiveFields(fieldName: string): FormField<VisitasModel>[] {
        return (this.reactiveForm.formFields.sections ?? [])
            .flatMap((section) => section.fields ?? [])
            .filter((field): field is FormField<VisitasModel> => field.name === fieldName);
    }

    private matchesVisitasCultivoOption(option: unknown): boolean {
        const cultivo = this.toRecord(option);

        if (cultivo === null) {
            return false;
        }

        if (this.showAllCultivosPrecedentes) {
            return true;
        }

        return (this.parcelas.values || [])
            .map((parcela) => parcela.value)
            .filter((parcela): parcela is ParcelasModel => parcela !== null)
            .filter((parcela) => String(parcela.id_finca ?? '') === String(this.id_finca ?? ''))
            .some((parcela) => String(parcela.id_cultivo ?? '') === String(cultivo['id'] ?? ''));
    }

    private matchesVisitasVariedadOption(option: unknown): boolean {
        const variedad = this.toRecord(option);

        if (variedad === null) {
            return false;
        }

        return (this.parcelas.values || [])
            .map((parcela) => parcela.value)
            .filter((parcela): parcela is ParcelasModel => parcela !== null)
            .filter((parcela) => String(parcela.id_finca ?? '') === String(this.id_finca ?? ''))
            .some((parcela) => String(parcela.id_variedad ?? '') === String(variedad['id'] ?? ''));
    }

    private hydrateVisitasDropdownSeeds(value: ReactiveFormValue<VisitasModel>): void {
        this.applyHydrationSeed('id_cultivo', value, ['cultivos_nombres', 'cultivo_nombre', 'nombre_cultivo', 'cultivo']);
        this.applyHydrationSeed('id_cultivo_precedente', value, ['cultivo_precedente_nombre', 'nombre_cultivo_precedente']);
        this.applyHydrationSeed('id_variedad', value, ['variedades_nombres', 'variedad_nombre', 'nombre_variedad', 'variedad']);
    }

    private applyHydrationSeed(
        fieldName: string,
        value: ReactiveFormValue<VisitasModel>,
        labelKeys: readonly string[],
    ): void {
        const fieldValue = this.getRecordValue(value, fieldName);
        const label = this.resolveHydrationLabel(value, fieldValue, labelKeys);

        if (!this.hasNonEmptyValue(fieldValue) || !this.hasNonEmptyValue(label)) {
            return;
        }

        for (const field of this.getReactiveFields(fieldName)) {
            const dropdown = field.input.data as DropdownData<unknown>;
            const option = { label, value: fieldValue, raw: { id: fieldValue, label } };
            const values = (dropdown.values ?? []).filter((item) => String(item.value ?? '') !== String(fieldValue));
            const filtered = (dropdown.filtered ?? []).filter((item) => String(item.value ?? '') !== String(fieldValue));

            dropdown.values = [option, ...values];
            dropdown.filtered = [option, ...filtered];
            dropdown.provenance = 'hydrationSeed';
        }
    }

    private resolveHydrationLabel(
        value: ReactiveFormValue<VisitasModel>,
        fieldValue: unknown,
        labelKeys: readonly string[],
    ): string {
        for (const key of labelKeys) {
            const label = this.getRecordValue(value, key);

            if (this.hasNonEmptyValue(label) && String(label) !== String(fieldValue)) {
                return String(label);
            }
        }

        return '';
    }

    private getInitialPreviousData(routeModel: VisitasModel): VisitasModel | null {
        return Object.keys(routeModel as Record<string, unknown>).length === 0
            ? null
            : this.toVisitasModel(routeModel as unknown as Record<string, unknown>);
    }

    private getReadableInitialisationError(error: unknown): string {
        if (error instanceof Error && error.message.trim() !== '') {
            return `No se ha podido cargar el formulario de visitas: ${error.message}`;
        }

        return 'No se ha podido cargar el formulario de visitas. Revisa la conexión y vuelve a intentarlo.';
    }

    private toVisitasFormValue(
        value: ReactiveFormValue<VisitasModel> | Partial<VisitasModel> | Record<string, unknown>,
    ): ReactiveFormValue<VisitasModel> {
        return { ...(value as Record<string, unknown>) } as ReactiveFormValue<VisitasModel>;
    }

    private toVisitasModel(
        value: ReactiveFormValue<VisitasModel> | Partial<VisitasModel> | Record<string, unknown>,
    ): VisitasModel {
        return { ...(value as Record<string, unknown>) } as unknown as VisitasModel;
    }

    private getRecordValue(value: Record<string, unknown>, key: string): unknown {
        return value[key];
    }

    private toRecord(value: unknown): Record<string, unknown> | null {
        return value !== null && typeof value === 'object' ? value as Record<string, unknown> : null;
    }

    private hasNonEmptyValue(value: unknown): boolean {
        return value !== null && value !== undefined && String(value).trim() !== '';
    }
}

